import React, { useContext } from 'react';
import { StoreContext } from 'store';
import './follow-us.scss';

const LOGOS = {
  DISCORD: (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        d="M19.2694 4.34399C17.8934 3.71467 16.432 3.256 14.9067 3C14.7147 3.33067 14.5013 3.77866 14.352 4.13067C12.7296 3.89599 11.1189 3.89599 9.51894 4.13067C9.3696 3.77866 9.14559 3.33067 8.96425 3C7.42828 3.256 5.96694 3.71467 4.60055 4.34399C1.83789 8.41865 1.09122 12.3973 1.46455 16.3226C3.29921 17.6559 5.0699 18.4666 6.80963 19C7.23629 18.424 7.6203 17.8053 7.95097 17.1546C7.32163 16.92 6.7243 16.632 6.1483 16.2906C6.29763 16.184 6.44697 16.0667 6.58564 15.9493C10.063 17.5387 13.8294 17.5387 17.264 15.9493C17.4133 16.0667 17.552 16.184 17.7013 16.2906C17.1253 16.632 16.528 16.92 15.8987 17.1546C16.2293 17.8053 16.6134 18.424 17.04 19C18.7787 18.4666 20.56 17.6559 22.3851 16.3226C22.8437 11.7787 21.6587 7.83202 19.2694 4.34399ZM8.43096 13.9013C7.38561 13.9013 6.53228 12.952 6.53228 11.7893C6.53228 10.6267 7.36428 9.67731 8.43096 9.67731C9.48694 9.67731 10.3509 10.6267 10.3296 11.7893C10.3296 12.952 9.48694 13.9013 8.43096 13.9013ZM15.44 13.9013C14.3947 13.9013 13.5403 12.952 13.5403 11.7893C13.5403 10.6267 14.3733 9.67731 15.44 9.67731C16.496 9.67731 17.36 10.6267 17.3387 11.7893C17.3387 12.952 16.5067 13.9013 15.44 13.9013Z"
        fill="#D4E7E5"
      />
    </svg>
  ),
  INSTA: (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.375 2C9.659 2 9.319 2.01133 8.25233 2.06C7.18767 2.10867 6.46033 2.278 5.82433 2.52533C5.15767 2.776 4.553 3.16933 4.053 3.67867C3.54448 4.17809 3.15091 4.78233 2.89967 5.44933C2.65367 6.08533 2.48367 6.81333 2.435 7.878C2.387 8.944 2.375 9.28333 2.375 12C2.375 14.7167 2.38633 15.056 2.435 16.1227C2.48367 17.1873 2.653 17.9147 2.90033 18.5507C3.151 19.2173 3.54433 19.822 4.05367 20.322C4.5531 20.8305 5.15734 21.2241 5.82433 21.4753C6.46033 21.722 7.18767 21.8913 8.25233 21.94C9.319 21.9887 9.659 22 12.375 22C15.091 22 15.431 21.9887 16.4977 21.94C17.5623 21.8913 18.2897 21.722 18.9257 21.4747C19.5923 21.224 20.197 20.8307 20.697 20.3213C21.2055 19.8219 21.5991 19.2177 21.8503 18.5507C22.097 17.9147 22.2663 17.1873 22.315 16.1227C22.3637 15.056 22.375 14.716 22.375 12C22.375 9.284 22.3637 8.944 22.315 7.87733C22.2663 6.81267 22.097 6.08533 21.8497 5.44933C21.5986 4.78204 21.205 4.17755 20.6963 3.678C20.1969 3.16948 19.5927 2.77591 18.9257 2.52467C18.2897 2.27867 17.5617 2.10867 16.497 2.06C15.431 2.012 15.0917 2 12.375 2ZM12.375 3.802C15.045 3.802 15.3617 3.812 16.4163 3.86C17.391 3.90467 17.9203 4.06667 18.273 4.20467C18.7397 4.38533 19.073 4.60267 19.423 4.952C19.773 5.302 19.9897 5.63533 20.1703 6.102C20.3077 6.45467 20.4703 6.984 20.515 7.95867C20.563 9.01333 20.573 9.33 20.573 12C20.573 14.67 20.563 14.9867 20.515 16.0413C20.4703 17.016 20.3083 17.5453 20.1703 17.898C20.0103 18.3324 19.7549 18.7253 19.423 19.048C19.1004 19.38 18.7074 19.6354 18.273 19.7953C17.9203 19.9327 17.391 20.0953 16.4163 20.14C15.3617 20.188 15.0457 20.198 12.375 20.198C9.70433 20.198 9.38833 20.188 8.33367 20.14C7.359 20.0953 6.82967 19.9333 6.477 19.7953C6.04264 19.6353 5.64967 19.3799 5.327 19.048C4.99512 18.7253 4.73975 18.3323 4.57967 17.898C4.44233 17.5453 4.27967 17.016 4.235 16.0413C4.187 14.9867 4.177 14.67 4.177 12C4.177 9.33 4.187 9.01333 4.235 7.95867C4.27967 6.984 4.44167 6.45467 4.57967 6.102C4.76033 5.63533 4.97767 5.302 5.327 4.952C5.64963 4.62003 6.04261 4.36465 6.477 4.20467C6.82967 4.06733 7.359 3.90467 8.33367 3.86C9.38833 3.812 9.705 3.802 12.375 3.802Z"
        fill="#D4E7E5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.375 15.3367C11.9368 15.3367 11.503 15.2504 11.0981 15.0827C10.6933 14.915 10.3255 14.6692 10.0156 14.3594C9.7058 14.0495 9.46002 13.6817 9.29234 13.2769C9.12465 12.8721 9.03835 12.4382 9.03835 12C9.03835 11.5618 9.12465 11.1279 9.29234 10.7231C9.46002 10.3183 9.7058 9.95046 10.0156 9.64062C10.3255 9.33078 10.6933 9.08501 11.0981 8.91732C11.503 8.74964 11.9368 8.66333 12.375 8.66333C13.26 8.66333 14.1086 9.01487 14.7344 9.64062C15.3601 10.2664 15.7117 11.1151 15.7117 12C15.7117 12.8849 15.3601 13.7336 14.7344 14.3594C14.1086 14.9851 13.26 15.3367 12.375 15.3367ZM12.375 6.86C11.0118 6.86 9.70442 7.40153 8.74049 8.36547C7.77655 9.32941 7.23502 10.6368 7.23502 12C7.23502 13.3632 7.77655 14.6706 8.74049 15.6345C9.70442 16.5985 11.0118 17.14 12.375 17.14C13.7382 17.14 15.0456 16.5985 16.0095 15.6345C16.9735 14.6706 17.515 13.3632 17.515 12C17.515 10.6368 16.9735 9.32941 16.0095 8.36547C15.0456 7.40153 13.7382 6.86 12.375 6.86ZM19.0103 6.76667C19.0103 7.0889 18.8823 7.39794 18.6545 7.6258C18.4266 7.85366 18.1176 7.98167 17.7954 7.98167C17.4731 7.98167 17.1641 7.85366 16.9362 7.6258C16.7084 7.39794 16.5803 7.0889 16.5803 6.76667C16.5803 6.44443 16.7084 6.13539 16.9362 5.90753C17.1641 5.67968 17.4731 5.55167 17.7954 5.55167C18.1176 5.55167 18.4266 5.67968 18.6545 5.90753C18.8823 6.13539 19.0103 6.44443 19.0103 6.76667Z"
        fill="#D4E7E5"
      />
    </svg>
  ),
  YT: (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9699 4.45999C21.9171 4.71353 22.6615 5.45785 22.915 6.40501C23.3732 8.12002 23.375 11.7004 23.375 11.7004C23.375 11.7004 23.375 15.2807 22.915 16.9957C22.6615 17.9429 21.9171 18.6872 20.9699 18.9407C19.255 19.4007 12.375 19.4007 12.375 19.4007C12.375 19.4007 5.49502 19.4007 3.78 18.9407C2.83285 18.6872 2.08853 17.9429 1.83499 16.9957C1.375 15.2807 1.375 11.7004 1.375 11.7004C1.375 11.7004 1.375 8.12002 1.83499 6.40501C2.08853 5.45785 2.83285 4.71353 3.78 4.45999C5.49502 4 12.375 4 12.375 4C12.375 4 19.255 4 20.9699 4.45999ZM15.8884 11.7007L10.1729 15.0003V8.40101L15.8884 11.7007Z"
        fill="#D4E7E5"
      />
    </svg>
  ),
  FB: (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        d="M22.375 12C22.375 6.47717 17.8979 2.00002 12.375 2.00002C6.85215 2.00002 2.375 6.47717 2.375 12C2.375 16.9913 6.03186 21.1283 10.8125 21.8785V14.8906H8.27344V12H10.8125V9.7969C10.8125 7.29065 12.3054 5.90627 14.5896 5.90627C15.6837 5.90627 16.8281 6.10159 16.8281 6.10159V8.56252H15.5671C14.3249 8.56252 13.9375 9.33336 13.9375 10.1242V12H16.7109L16.2676 14.8906H13.9375V21.8785C18.7181 21.1283 22.375 16.9913 22.375 12Z"
        fill="#D4E7E5"
      />
    </svg>
  ),
  TWITTER: (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        d="M18.1263 2.5H21.193L14.493 10.5481L22.375 21.5H16.2035L11.3697 14.8578L5.83856 21.5H2.76997L9.9364 12.8914L2.375 2.5H8.7033L13.0726 8.57121L18.1263 2.5ZM17.0499 19.5707H18.7492L7.77984 4.3278H5.95638L17.0499 19.5707Z"
        fill="#D4E7E5"
      />
    </svg>
  ),
};

export const FollowUs = () => {
  const {
    translation: t,
    location: [country],
  } = useContext(StoreContext);

  return (
    <div className="c-follow-us">
      <div className="c-follow-us__content">
        <div className="c-follow-us__title">{t.footer.followUs}</div>
        <div className="c-follow-us__items">
          <a
            href="https://discord.com/invite/tacticool"
            target="_blank"
            className="follow-us__item"
            rel="noreferrer"
          >
            {LOGOS.DISCORD}
          </a>
          {!country || country === 'RU' ? null : (
            <a
              href="https://www.instagram.com/tacticoolgame/"
              target="_blank"
              className="follow-us__item"
              rel="noreferrer"
            >
              {LOGOS.INSTA}
            </a>
          )}
          <a
            href="https://www.youtube.com/c/Panzerdog"
            target="_blank"
            className="follow-us__item"
            rel="noreferrer"
          >
            {LOGOS.YT}
          </a>
          {!country || country === 'RU' ? null : (
            <a
              href="https://www.facebook.com/TacticoolGame"
              target="_blank"
              className="follow-us__item"
              rel="noreferrer"
            >
              {LOGOS.FB}
            </a>
          )}
          <a
            href="https://twitter.com/TacticoolGame"
            target="_blank"
            className="follow-us__item"
            rel="noreferrer"
          >
            {LOGOS.TWITTER}
          </a>
        </div>
      </div>
    </div>
  );
};
